import {setupDemoForm} from "layouts/_demo_form";
import * as smoothscroll from "smoothscroll-polyfill";
import * as Animations from "./animations";
import "./corporate.scss";

declare var $: any;

smoothscroll.polyfill();

document.addEventListener("DOMContentLoaded", () => {
  function scrollToDemoSection(smooth: boolean = true) {
    document.getElementById("demo-section")!.scrollIntoView({
      behavior: smooth ? "smooth" : "auto",
      block: "start",
    });
    setTimeout(() => {
      const firstInput = document.getElementById("id_first_name");
      if (firstInput) {
        firstInput.focus();
      }
    }, 1000);
  }

  document.getElementById("demo-button")!.addEventListener("click", (ev) => {
    ev.preventDefault();
    scrollToDemoSection();
  });

  const form = document.getElementById("demo-form");
  if (form && form.className.includes("success")) {
    scrollToDemoSection(false);
  }

  setupDemoForm();
  const route = window.location.hash.substring(1);
  if (route === "demo-section") {
    scrollToDemoSection(false);
  }

  Animations.setupAnimations([
    "#use-case-hiring",
    "#use-case-product-pricing",
    "#use-case-map",
    "#use-case-car",
    "#use-case-hiring-hr",
    "#use-case-employee",
    "#use-case-recruitment",
    "#use-case-reit",
    "#use-case-jobs",
    "#use-case-daily-car",
    "#use-case-reddit-rounded",
    "#use-case-reddit-words",
    "#thinknum-media",
  ]);

  $(".owl-carousel").owlCarousel({
    loop: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    items: 1,
    smartSpeed: 750,
    margin: 20,
  });
});
